import { Component } from '@angular/core';

@Component({
  selector: 'app-info',
  imports: [],
  template: `<svg
  width="16"
  height="16"
  viewBox="0 0 22 22"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M11.314 16.3021C11.0828 16.2991 10.862 16.2059 10.6986 16.0425C10.5351 15.879 10.442 15.6582 10.439 15.4271V9.59375C10.439 9.36169 10.5312 9.13913 10.6952 8.97503C10.8593 8.81094 11.0819 8.71875 11.314 8.71875C11.546 8.71875 11.7686 8.81094 11.9327 8.97503C12.0968 9.13913 12.189 9.36169 12.189 9.59375V15.4271C12.1859 15.6582 12.0928 15.879 11.9293 16.0425C11.7659 16.2059 11.5451 16.2991 11.314 16.3021V16.3021Z"
    fill="#183A25"
  />
  <path
    d="M11.314 7.55208C11.0828 7.54906 10.862 7.4559 10.6986 7.29246C10.5351 7.12902 10.442 6.90821 10.439 6.67708V6.09375C10.439 5.86169 10.5312 5.63913 10.6952 5.47503C10.8593 5.31094 11.0819 5.21875 11.314 5.21875C11.546 5.21875 11.7686 5.31094 11.9327 5.47503C12.0968 5.63913 12.189 5.86169 12.189 6.09375V6.67708C12.1859 6.90821 12.0928 7.12902 11.9293 7.29246C11.7659 7.4559 11.5451 7.54906 11.314 7.55208Z"
    fill="#183A25"
  />
  <path
    d="M11.314 21.2607C9.23726 21.2607 7.2072 20.6449 5.48048 19.4912C3.75377 18.3374 2.40795 16.6975 1.61323 14.7789C0.818514 12.8603 0.610579 10.7491 1.01572 8.7123C1.42087 6.6755 2.4209 4.80458 3.88935 3.33612C5.3578 1.86767 7.22872 0.867646 9.26552 0.462501C11.3023 0.0573567 13.4135 0.265292 15.3321 1.06001C17.2508 1.85473 18.8906 3.20054 20.0444 4.92726C21.1982 6.65397 21.814 8.68404 21.814 10.7607C21.814 13.5455 20.7077 16.2162 18.7386 18.1854C16.7695 20.1545 14.0987 21.2607 11.314 21.2607V21.2607ZM11.314 2.01075C9.58338 2.01075 7.89166 2.52393 6.45273 3.48539C5.0138 4.44685 3.89229 5.81341 3.23002 7.41227C2.56776 9.01112 2.39448 10.7705 2.7321 12.4678C3.06972 14.1651 3.90308 15.7242 5.12678 16.9479C6.35049 18.1716 7.90959 19.005 9.60693 19.3426C11.3043 19.6802 13.0636 19.507 14.6624 18.8447C16.2613 18.1824 17.6279 17.0609 18.5893 15.622C19.5508 14.1831 20.064 12.4913 20.064 10.7607C20.064 8.4401 19.1421 6.2145 17.5011 4.57356C15.8602 2.93262 13.6346 2.01075 11.314 2.01075Z"
    fill="#183A25"
  />
</svg>
`
})
export class InfoComponent {

}
